import { render, staticRenderFns } from "./DoctorData.vue?vue&type=template&id=743a9949&scoped=true&"
import script from "./DoctorData.vue?vue&type=script&lang=js&"
export * from "./DoctorData.vue?vue&type=script&lang=js&"
import style0 from "./DoctorData.vue?vue&type=style&index=0&id=743a9949&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "743a9949",
  null
  
)

export default component.exports